import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/cross.svg'
import _imports_1 from '@/assets/img/arrow.down.svg'
import _imports_2 from '@/assets/img/edit.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "col-sm-3" }
const _hoisted_13 = { class: "col-sm-3" }
const _hoisted_14 = { class: "d-block" }
const _hoisted_15 = {
  key: 0,
  class: "row"
}
const _hoisted_16 = { class: "col-sm-6" }
const _hoisted_17 = { class: "col-sm-6" }
const _hoisted_18 = {
  key: 1,
  class: "row"
}
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-sm-4" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "input_title" }
const _hoisted_23 = { class: "col-sm-8" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-sm-3" }
const _hoisted_26 = { class: "col-sm-3" }
const _hoisted_27 = { class: "col-sm-3" }
const _hoisted_28 = { class: "col-sm-3" }
const _hoisted_29 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_30 = { class: "col-sm-3" }
const _hoisted_31 = { class: "col-sm-3" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "col-sm-3" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "col-sm-3" }
const _hoisted_38 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "d-flex justify-content-center my-4 pt-3" }
const _hoisted_43 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_44 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = {
  key: 0,
  class: "accordion-body px-0 pt-4"
}
const _hoisted_51 = { class: "col-sm-3" }
const _hoisted_52 = { class: "col-sm-3" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { class: "col-sm-3" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { class: "col-sm-3" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-5" }, null, -1)
const _hoisted_62 = { class: "form-group mt-5" }
const _hoisted_63 = { class: "d-block mb-3" }
const _hoisted_64 = {
  class: "d-flex flex-wrap",
  style: {"max-width":"600px"}
}
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "form-group" }
const _hoisted_67 = { class: "d-block mb-3" }
const _hoisted_68 = {
  class: "d-flex flex-wrap",
  style: {"max-width":"600px"}
}
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { class: "text-center mt-5" }
const _hoisted_71 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_72 = ["disabled"]
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Edit Configuration",
          text: "Edit Configuration"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_form_field, {
              type: "text",
              labelKey: "Material Name",
              labelValue: "Material Name",
              placeholderKey: "Material Name",
              placeholderValue: "Material Name",
              modelValue: _ctx.localModel.materialName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localModel.materialName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_form_field, {
              type: "select",
              labelKey: "Material Parent",
              labelValue: "Material Parent",
              placeholderKey: "Material Parent",
              placeholderValue: "Material Parent",
              list: _ctx.rawMatIds,
              modelValue: _ctx.localModel.parent.identifier,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModel.parent.identifier) = $event))
            }, null, 8, ["list", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_form_field, {
              type: "select-string",
              labelKey: "Material Category",
              labelValue: "Material Category",
              placeholderKey: "Material Category",
              placeholderValue: "Material Category",
              list: _ctx.categories,
              modelValue: _ctx.localModel.category,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localModel.category) = $event))
            }, null, 8, ["list", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_form_field, {
              type: "text",
              labelKey: "Country",
              labelValue: "Country",
              placeholderKey: "Country",
              placeholderValue: "Country",
              modelValue: _ctx.localModel.country,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localModel.country) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: "form-group pointer w-100 ms-2",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.localModel.isLeather = !_ctx.localModel.isLeather))
            }, [
              _createElementVNode("label", _hoisted_14, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Is Leather",
                  text: "Is Leather"
                })
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.localModel.isLeather}])
              }, null, 2)
            ])
          ])
        ]),
        (!_ctx.isProcessBased)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_form_field, {
                  type: "number",
                  labelKey: "GRAMS Suggested",
                  labelValue: "GRAMS Suggested",
                  placeholderKey: "GRAMS Suggested",
                  placeholderValue: "GRAMS Suggested",
                  modelValue: _ctx.localModel.suggestedGramsPerSquareMeters,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localModel.suggestedGramsPerSquareMeters) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_form_field, {
                  type: "number",
                  labelKey: "CO2 Per Grams",
                  labelValue: "CO2 Per Grams",
                  placeholderKey: "CO2 Per Grams",
                  placeholderValue: "CO2 Per Grams",
                  modelValue: _ctx.localModel.cO2PerGrams,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localModel.cO2PerGrams) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processKeys, (key) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-sm-4",
                  key: key
                }, [
                  _createVNode(_component_form_field, {
                    type: "number",
                    labelKey: key,
                    labelValue: key,
                    placeholderKey: key,
                    placeholderValue: key,
                    modelValue: _ctx.localModel.emissionFactorFootwearType[key],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.localModel.emissionFactorFootwearType[key]) = $event)
                  }, null, 8, ["labelKey", "labelValue", "placeholderKey", "placeholderValue", "modelValue", "onUpdate:modelValue"])
                ]))
              }), 128))
            ])),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Land impact NOT available",
                  text: "Land impact NOT available",
                  class: "fev_text5 fw_600"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localModel.landImpactNOTAvailable) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.localModel.landImpactNOTAvailable]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_form_field, {
              type: "number",
              labelKey: "Land impact (m2/g)",
              labelValue: "Land impact (m2/g)",
              placeholderKey: "Land impact (m2/g)",
              placeholderValue: "Land impact (m2/g)",
              modelValue: _ctx.localModel.landImpact,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localModel.landImpact) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_localized_text, {
          localizedKey: "Water footprint (default)",
          text: "Water footprint (default)",
          type: "h4",
          class: "mt-3 mb-4"
        }),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_form_field, {
              type: "select",
              labelKey: "Production phase",
              labelValue: "Production phase",
              placeholderKey: "Production phase",
              placeholderValue: "Production phase",
              list: _ctx.remainingPhasesIIds,
              modelValue: _ctx.newWaterFootprintRow.productionPhase.identifier,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newWaterFootprintRow.productionPhase.identifier) = $event))
            }, null, 8, ["list", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_form_field, {
              type: "number",
              labelKey: "Green water (ml/g)",
              labelValue: "Green water (ml/g)",
              placeholderKey: "Green water (ml/g)",
              placeholderValue: "Green water (ml/g)",
              modelValue: _ctx.newWaterFootprintRow.greenWater,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newWaterFootprintRow.greenWater) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_form_field, {
              type: "number",
              labelKey: "Blue water (ml/g)",
              labelValue: "Blue water (ml/g)",
              placeholderKey: "Blue water (ml/g)",
              placeholderValue: "Blue water (ml/g)",
              modelValue: _ctx.newWaterFootprintRow.blueWater,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newWaterFootprintRow.blueWater) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_form_field, {
                type: "number",
                labelKey: "Grey water (ml/g)",
                labelValue: "Grey water (ml/g)",
                placeholderKey: "Grey water (ml/g)",
                placeholderValue: "Grey water (ml/g)",
                modelValue: _ctx.newWaterFootprintRow.greyWater,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newWaterFootprintRow.greyWater) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tertiary ms-2",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addWaterFootprintRow()))
              }, " + ")
            ])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaultWaterFootprints, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "row align-items-center mb-2",
            key: index
          }, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("span", null, _toDisplayString(item.productionPhase.text), 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              (item.greenWater)
                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(item.greenWater) + " ml/g", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_33, "--"))
            ]),
            _createElementVNode("div", _hoisted_34, [
              (item.blueWater)
                ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(item.blueWater) + " ml/g", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_36, "--"))
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                (item.greyWater)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(item.greyWater) + " ml/g", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_40, "--")),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary ms-2",
                  onClick: ($event: any) => (_ctx.removeWaterFootprintRow(index))
                }, " - ", 8, _hoisted_41)
              ])
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-tertiary",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.overrideWaterFootprintDefaultConfig('')))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Override water footprint default configuration for garment",
              text: "Override water footprint default configuration for garment"
            })
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedWaterFootprintsByGarment, (group, garment) => {
          return (_openBlock(), _createElementBlock("div", {
            key: garment,
            class: "accordion mb-3"
          }, [
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_localized_text, {
                localizedKey: 'Water footprint (' + garment + ')',
                text: 'Water footprint (' + garment + ')',
                type: "h4",
                class: "mb-0"
              }, null, 8, ["localizedKey", "text"]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("button", {
                  class: "btn btn-secondary px-2 ms-1",
                  onClick: ($event: any) => (_ctx.toggleWaterFootprintAccordion(garment))
                }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: _normalizeClass(["rotatingArrow", {'rotate': _ctx.opened.includes(garment)}])
                  }, null, 2)
                ], 8, _hoisted_45),
                _createElementVNode("button", {
                  class: "btn btn-secondary px-2 ms-1",
                  onClick: ($event: any) => (_ctx.overrideWaterFootprintDefaultConfig(garment))
                }, _hoisted_48, 8, _hoisted_46),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary ms-1",
                  onClick: ($event: any) => (_ctx.removeWaterFootprintOvveride(garment))
                }, " - ", 8, _hoisted_49)
              ])
            ]),
            (_ctx.opened.includes(garment))
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row align-items-center mb-4",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("span", null, _toDisplayString(item.productionPhase.text), 1)
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        (item.greenWater)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(item.greenWater) + " ml/g", 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_54, "--"))
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        (item.blueWater)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(item.blueWater) + " ml/g", 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_57, "--"))
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        (item.greyWater)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(item.greyWater) + " ml/g", 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_60, "--"))
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _hoisted_61,
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("label", _hoisted_63, [
            (_ctx.isProcessBased)
              ? (_openBlock(), _createBlock(_component_localized_text, {
                  key: 0,
                  localizedKey: "Garments (at least one is required)",
                  text: "Garments (at least one is required)"
                }))
              : (_openBlock(), _createBlock(_component_localized_text, {
                  key: 1,
                  localizedKey: "Garments (if empty it will be available to each garment)",
                  text: "Garments (if empty it will be available to each garment)"
                }))
          ]),
          _createElementVNode("div", _hoisted_64, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.garmentIds, (garment, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "pointer d-flex align-items-center me-3 mb-2",
                key: index,
                onClick: ($event: any) => (_ctx.toggleGarment(garment.identifier))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.localModel.garmentsUsage.indexOf(garment.identifier) > -1}])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(garment.text), 1)
              ], 8, _hoisted_65))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("label", _hoisted_67, [
            _createVNode(_component_localized_text, {
              localizedKey: "Companies (if empty it will be available to each company)",
              text: "Companies (if empty it will be available to each company)"
            })
          ]),
          _createElementVNode("div", _hoisted_68, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (company, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "pointer d-flex align-items-center me-3 mb-2",
                key: index,
                onClick: ($event: any) => (_ctx.toggleCompany(company.identifier))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["sameAsCheckbox me-2", {'active': _ctx.localModel.companiesUsage.indexOf(company.identifier) > -1}])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(company.companyName), 1)
              ], 8, _hoisted_69))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_70, [
        (_ctx.isProcessBased && !_ctx.processFactorsValid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
              _createVNode(_component_localized_text, {
                localizedKey: "Every emission factor is required and must be greater than zero.",
                text: "Every emission factor is required and must be greater than zero."
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: !_ctx.canSave,
          onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          (!_ctx.localModel.identifier)
            ? (_openBlock(), _createElementBlock("span", _hoisted_73, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Create",
                  text: "Create"
                })
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_74, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Edit",
                  text: "Edit"
                })
              ]))
        ], 8, _hoisted_72)
      ])
    ])
  ]))
}